export default __webpack_public_path__ + "static/favicon-44d2fe1876c8711ea78bc9984b5481bb.ico";